<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-card elevation="1" tile class="pa-2">
          <canvas id="claims-chart-one"></canvas>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card elevation="1" tile class="pa-2" height="100%">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Reclamos
                  </th>
                  <th class="text-left">
                    Cantidad
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in grilla" :key="item.name">
                  <td>{{ item.name }}</td>
                  <td>{{ item.value }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-if="false">
        <v-card elevation="1" tile class="pa-2">
          <canvas id="claims-chart-three"></canvas>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-if="false">
        <v-card elevation="1" tile class="pa-2">
          <canvas id="claims-chart-four"></canvas>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import baseViewMixin from "@/mixins/baseView";
import currentUserMixin from "@/mixins/currentUser";
import currentDashboardMixin from "@/mixins/currentDashboard";

import Chart from "chart.js";

export default {
  mixins: [baseViewMixin, currentUserMixin, currentDashboardMixin],
  data() {
    return {
      graphDataForDDCExecutive: {
        datasets: [
          {
            data: [],
            backgroundColor: [
              "#F44336", //Ingresados
              "#E91E63", //Por asignar
              "#9C27B0", //pendiente antecedentes adicionales
              "#3F51B5", //Pendiente cliente
              "#795548", //Pendiente banco
              "#009688", //Pendiente defensor
            ],
            label: "Reclamos",
          },
        ],
        labels: [
          "Por revisar",
          "Por asignar",
          "Antecedentes adicionales pendiente",
          "Pendiente cliente",
          "Pendiente banco",
          "Pendiente defensor",
        ],
      },
      graphDataForBankAdministrator: {
        datasets: [
          {
            data: [],
            backgroundColor: [
              "#F44336", //Ingresados
              "#E91E63", //Por Responder
              "#9C27B0", //Prorrogables
              "#3F51B5", //pendiente antecedentes adicionales
              "#795548", //Pendiente Cliente
              "#009688", //Pendiente Ejecutivo DDC
              "#607D8B", //Pendiente Defensor
              //"#ADDCAF"   //Cerrados
            ],
            label: "Reclamos",
          },
        ],
        labels: [
          "Ingresados",
          "Por responder",
          "Prorrogables",
          "Entregar antecedentes adicionales",
          "Pendiente cliente",
          "Pendiente ejecutivo DDC",
          "Pendiente defensor",
        ],
      },
      graphDataForDDCDefender: {
        datasets: [
          {
            data: [],
            backgroundColor: [
              "#F44336", //Pendiente defensor
              "#E91E63", //Incompatibles
              "#9C27B0", //pendiente antecedentes adicionales
              "#3F51B5", //Pendiente Cliente
              "#795548", //Pendiente Banco
              //"#ADDCAF"   //Resueltos
            ],
            label: "Reclamos",
          },
        ],
        labels: [
          "Pendiente defensor",
          "Incompatibles",
          "Pendiente antecedentes adicionales",
          "Pendiente cliente",
          "Pendiente banco",
        ],
      },
      graphDataForBankExecutive: {
        datasets: [
          {
            data: [],
            backgroundColor: [
              "#F44336", //Ingresados
              "#E91E63", //Por responder
              "#9C27B0", //Prorrogables
              "#3F51B5", //pendiente antecedentes adicionales
              "#795548", //Pendiente cliente
              "#009688", //Pendiente ejecutivo DDC
              "#607D8B", //Pendiente defensor
            ],
            label: "Reclamos",
          },
        ],
        labels: [
          "Ingresados",
          "Por responder",
          "Prorrogables",
          "Entregar antecedentes adicionales",
          "Pendiente cliente",
          "Pendiente ejecutivo DDC",
          "Pendiente defensor",
        ],
      },
    };
  },
  computed: {
    data() {
      if (
        this.currentUserInfo.roles[0] ==
        this.allConstants.security.userRolesCodes.ddcExecutive
      ) {
        this.cleanExecutive();
        this.addDdcExecutive(this.currentDashboard.ddcExecutive.claimsToAdmit);
        this.addDdcExecutive(
          this.currentDashboard.ddcExecutive.claimsPendingAssignment
        );
        this.addDdcExecutive(
          this.currentDashboard.ddcExecutive.claimsSendPapers
        );
        this.addDdcExecutive(
          this.currentDashboard.ddcExecutive.claimsPendingClient
        );
        this.addDdcExecutive(
          this.currentDashboard.ddcExecutive.claimsPendingBank
        );
        this.addDdcExecutive(
          this.currentDashboard.ddcExecutive.claimsPendingDefender
        );

        return this.graphDataForDDCExecutive;
      }

      if (
        this.currentUserInfo.roles[0] ==
        this.allConstants.security.userRolesCodes.bankAdministrator
      ) {
        this.cleanAdministrator();
        this.addBankAdministrator(
          this.currentDashboard.bankAdministrator.claimsCreated
        );
        this.addBankAdministrator(
          this.currentDashboard.bankAdministrator.claimsForAnswer
        );
        this.addBankAdministrator(
          this.currentDashboard.bankAdministrator.claimsInExtension
        );
        this.addBankAdministrator(
          this.currentDashboard.bankAdministrator.claimsSendPapers
        );
        this.addBankAdministrator(
          this.currentDashboard.bankAdministrator.claimsPendingClient
        );
        this.addBankAdministrator(
          this.currentDashboard.bankAdministrator.claimsPendingDDC
        );
        this.addBankAdministrator(
          this.currentDashboard.bankAdministrator.claimsPendingDefender
        );

        return this.graphDataForBankAdministrator;
      }

      if (
        this.currentUserInfo.roles[0] ==
        this.allConstants.security.userRolesCodes.ddcDefender
      ) {
        this.cleanDefender();
        this.addDDCDefender(this.currentDashboard.ddcDefender.claimsAssigned);
        this.addDDCDefender(
          this.currentDashboard.ddcDefender.claimsNotCompatible
        );
        this.addDDCDefender(this.currentDashboard.ddcDefender.claimsSendPapers);
        this.addDDCDefender(
          this.currentDashboard.ddcDefender.claimsPendingClient
        );
        this.addDDCDefender(
          this.currentDashboard.ddcDefender.claimsPendingBank
        );

        return this.graphDataForDDCDefender;
      }

      if (
        this.currentUserInfo.roles[0] ==
        this.allConstants.security.userRolesCodes.bankExecutive
      ) {
        this.cleanBankExecutive();
        this.addBankExecutive(
          this.currentDashboard.bankExecutive.claimsCreated
        );
        this.addBankExecutive(
          this.currentDashboard.bankExecutive.claimsPendingResponse
        );
        this.addBankExecutive(
          this.currentDashboard.bankExecutive.claimsInExtension
        );
        this.addBankExecutive(
          this.currentDashboard.bankExecutive.claimsSendPapers
        );
        this.addBankExecutive(
          this.currentDashboard.bankExecutive.claimsPendingClient
        );
        this.addBankExecutive(
          this.currentDashboard.bankExecutive.claimsPendingDDC
        );
        this.addBankExecutive(
          this.currentDashboard.bankExecutive.claimsPendingDefender
        );

        return this.graphDataForBankExecutive;
      }

      return null;
    },
    grilla() {
      let result = [];
      for (let i = 0; i < this.data.labels.length; i++) {
        result.push({
          name: this.data.labels[i],
          value: this.data.datasets[0].data[i],
        });
      }

      return result;
    },
  },
  methods: {
    cleanExecutive() {
      this.graphDataForDDCExecutive.datasets[0].data = [];
    },
    addDdcExecutive(value) {
      this.graphDataForDDCExecutive.datasets[0].data.push(value);
    },
    cleanAdministrator() {
      this.graphDataForBankAdministrator.datasets[0].data = [];
    },
    addBankAdministrator(value) {
      this.graphDataForBankAdministrator.datasets[0].data.push(value);
    },
    cleanDefender() {
      this.graphDataForDDCDefender.datasets[0].data = [];
    },
    addDDCDefender(value) {
      this.graphDataForDDCDefender.datasets[0].data.push(value);
    },
    cleanBankExecutive() {
      this.graphDataForBankExecutive.datasets[0].data = [];
    },
    addBankExecutive(value) {
      this.graphDataForBankExecutive.datasets[0].data.push(value);
    },
    createChart(id, type, data) {
      const ctx = document.getElementById(id);

      new Chart(ctx, {
        type: type,
        data: data,
        options: { responsive: true },
      });
    },
  },
  mounted() {
    this.createChart("claims-chart-one", "pie", this.data);
    //this.createChart("claims-chart-two", "bar", data);
    //this.createChart("claims-chart-three", "horizontalBar", this.data);
    //this.createChart("claims-chart-four", "doughnut", this.data);
  },
};
</script>

<style lang="scss" scoped></style>
